"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
const utils_1 = require("../../private/utils/utils");
/**
 * @description Node api service that returns Promises of (lists of) @interface iNode .
 *
 * @export
 * @class Node
 */
class Node {
    /**
     *Creates an instance of Node.
     * @memberof Node
     */
    constructor() {
        if (!(authData_1.Auth.getUserToken() && authData_1.Auth.getDomainToken())) {
            throw new Error('Cannot use Node service without authenticated user and opened domain!, ' +
                'please use the Authenticator service first');
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
    }
    /**
     * @description get a node by the given Id. Resloving the promise or awaiting it will return the node.
     * only the required properties of @type {iNode} will be included.
     *
     * @param {number} nodeId
     * @returns {Promise<iNode>}
     * @memberof Node
     */
    get(nodeId) {
        return this.api.get(`node/${nodeId}`);
    }
    /**
     * @deprecated
     *
     * @description get a node by the given Id where all optional fields of @type {iNode} are included.
     *
     * @param {number} nodeId
     * @returns {Promise<iNode>}
     * @memberof Node
     */
    getFull(nodeId) {
        return this.api.get(`node/${nodeId}/full`);
    }
    /**
     * @description get a list of nodes by the given Ids. Resloving the promise or awaiting it will return the nodes.
     *
     *
     * @param {number[]} ids
     * @param {string[]} populatedFields
     * @returns {Promise<iNode[]>}
     * @memberof Node
     */
    getMany(ids) {
        return this.api.getSearchQuery('node', {
            id: ids
        });
    }
    /**
     * @description update a node by sending a @interface iNode with all fields you want to be updated. Resloving the promise or awaiting it will return the updated node.
     *
     *
     * @param {Partial<iNode>} node
     * @returns {Promise<iNode>}
     * @memberof Node
     */
    update(updatedNode) {
        return this.api.put(`node/${updatedNode.id}`, updatedNode);
    }
    /**
     * @description update multiple node by sending list of @interface iNode with all fields you want to be updated. Resloving the promise or awaiting it will return the updated nodes.   *
     *
     * @param {Array<Partial<iNode>>} nodes
     * @returns {Promise<iNode[]>}
     * @memberof Node
     */
    updateMany(nodes) {
        return this.api.putMany(`node/groupUpdate`, nodes);
    }
    /**
     * @description create a node by sending a @interface iNode with all fields you want to be created. Resloving the promise or awaiting it will return the created node.   *
     *
     *
     * @param {Partial<iNode>} node
     * @returns {Promise<iNode>}
     * @memberof Node
     */
    create(newNode) {
        return this.api.post(`node`, newNode);
    }
    /**
     * @description create nodes by sending a list of @interface iNode with all fields you want to be created. Resloving the promise or awaiting it will return the created nodes.   *
     *
     *
     * @param {Partial<iNode>[]} nodes
     * @returns {Promise<iNode[]>}
     * @memberof Node
     */
    createMany(nodes) {
        return this.api.post(`node/bulk`, nodes);
    }
    /**
     * @description delete a Node. Succes returns void.
     *
     * @param {number} nodeId
     * @returns {Promise<void>}
     * @memberof Node
     */
    delete(nodeId) {
        return this.api.delete(`node/${nodeId}`);
    }
    /**
     * @description delete many Nodes.
     *
     * @param {array} nodeIds
     * @returns {Promise<void>}
     * @memberof Node
     */
    deleteMany(nodeIds) {
        return this.api.delete(`node/many`, {
            data: { 'ids': nodeIds }
        });
    }
    /**
     * @description get a list within a specified range, optional of a type.
     *
     * @param {number} [skip=0]
     * @param {number} [limit]
     * @returns {Promise<iNode[]>}
     * @memberof Node
     */
    list(skip = 0, limit) {
        console.warn('This endpoint is deprecated');
        return this.api.getSearchQuery('node/list', utils_1._utils.literal({ skip, limit }));
    }
    /**
     * @description general queryby the sails Waterline query language syntax, @see https://sailsjs.com/documentation/concepts/models-and-orm/query-language
     *
     * @param {iQuery} whereClause : the where clause of the Waterline query. @see https://sailsjs.com/documentation/concepts/models-and-orm/query-language for documentation
     * @param {string[]} populatedFields : an array of strings that correspond with attribute names. The record ID is always returned.
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {iQuery[]} [sort] - i.e. [{ name:  'ASC'}, { age: 'DESC' }]
     * @returns {Promise<iNode[]>}
     * @memberof Node
     */
    find(whereClause, populatedFields, skip, limit, sort) {
        return this.api.postSearchQuery('node/find', utils_1._utils.literal({
            where: utils_1._utils.literal(whereClause),
            populate: populatedFields,
            skip,
            limit,
            sort
        }));
    }
    getAttatchedRelations(nodeId) {
        return this.api.post(`node/populateRelations`, {
            nodeId
        });
    }
    /**
     * @deprecated
     * @param name
     * @param label
     * @returns
     */
    getSuggestions(name, label) {
        let params = { name };
        if (label)
            params = { name, label };
        return this.api.getSearchQuery('node/suggestions', params);
    }
    /**
     * Get Node Suggestions for ontology
     *
     * @param q
     * @param ontologyId
     * @returns
     */
    getNodeSuggestions(q, ontologyId) {
        return this.api.getSearchQuery('node/nodeSuggestions', {
            name: q,
            ontology_id: ontologyId
        });
    }
    createSeed(suggestion) {
        return this.api.post('node/seed', { suggestion });
    }
    createNodeWithSuggestion(nodeSeed) {
        return this.api.post('node/suggestion', { nodeSeed });
    }
    applySuggestion(nodeId, suggestion) {
        return this.api.patch(`node/${nodeId}/suggestion`, {
            suggestion
        });
    }
}
exports.Node = Node;
//# sourceMappingURL=data:application/json;base64,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